module.exports = __webpack_public_path__ + "media/images/favicon-b24e0075226a448e91572df7ee21f4f9.png";